import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class EsignTemplate extends BaseEntityModel {
  /**
   * @var {string}
   */
  key;

  /**
   * @var {string}
   */
  name;

  constructor(model = {}) {
    super(model);

    this.key = model.key;
    this.name = model.name;
  }
}
